function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "disable",
  transform: "translate(1692 -328)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_12313",
  "data-name": "Group 12313",
  transform: "translate(35 33)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_12979",
  "data-name": "Path 12979",
  d: "M-20.4-15.824h-2.7a.879.879,0,0,1-.9-.853l0-2.78-2.653-2.68A3.946,3.946,0,0,1-28-21.9a4.03,4.03,0,0,1-4-4.05,4.087,4.087,0,0,1,.232-1.356L-35-30.571-33.586-32-15.2-13.429-16.615-12ZM-20-13.8H-36v-2.025c0-2.66,5.208-4.051,8-4.051a13.838,13.838,0,0,1,3,.388l0,3.822a.879.879,0,0,0,.9.853H-20V-13.8h0Zm4.375-2.066L-21.9-22.219h.6v-.852a.879.879,0,0,1,.9-.853h1.8a.879.879,0,0,1,.9.853v.852h1.8a.878.878,0,0,1,.9.852v4.69a.855.855,0,0,1-.625.813ZM-20.4-22.219h1.8v-.852h-1.8Zm-3.836-2.364-5.115-5.179A3.934,3.934,0,0,1-28-30a4.03,4.03,0,0,1,4,4.051,4.089,4.089,0,0,1-.234,1.366v0Z",
  transform: "translate(-1689 329)",
  fill: "#CDCDCC"
})), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_18460",
  "data-name": "Rectangle 18460",
  width: 24,
  height: 24,
  transform: "translate(-1692 328)",
  fill: "none"
}));

function SvgDisable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisable);
export default __webpack_public_path__ + "static/media/disable.ff4fc9a2.svg";
export { ForwardRef as ReactComponent };